import styles from "./styles.module.scss"
import AuthTitle from "./widget";

export default AuthTitle;
export {styles};